var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowrightwhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3 17.6508C13.1 17.4508 13.004 17.2091 13.012 16.9258C13.02 16.6424 13.1243 16.4008 13.325 16.2008L16.15 13.3758H5C4.71667 13.3758 4.479 13.2798 4.287 13.0878C4.095 12.8958 3.99934 12.6584 4 12.3758C4 12.0924 4.096 11.8548 4.288 11.6628C4.48 11.4708 4.71734 11.3751 5 11.3758H16.15L13.3 8.52578C13.1 8.32578 13 8.08811 13 7.81278C13 7.53745 13.1 7.30011 13.3 7.10078C13.5 6.90078 13.7377 6.80078 14.013 6.80078C14.2883 6.80078 14.5257 6.90078 14.725 7.10078L19.3 11.6758C19.4 11.7758 19.471 11.8841 19.513 12.0008C19.555 12.1174 19.5757 12.2424 19.575 12.3758C19.575 12.5091 19.554 12.6341 19.512 12.7508C19.47 12.8674 19.3993 12.9758 19.3 13.0758L14.7 17.6758C14.5167 17.8591 14.2877 17.9508 14.013 17.9508C13.7383 17.9508 13.5007 17.8508 13.3 17.6508Z",
    fill: "#EBF0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowrightwhite);
export default __webpack_public_path__ + "static/media/arrowrightwhite.91a9788d50b5a9981ddb42cef10a70c1.svg";
export { ForwardRef as ReactComponent };